import { render, staticRenderFns } from "./WeShadow.vue?vue&type=template&id=d334e4ae&"
import script from "./WeShadow.vue?vue&type=script&lang=js&"
export * from "./WeShadow.vue?vue&type=script&lang=js&"
import style0 from "./WeShadow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports